/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
    CriteriaQualifierToJSONTyped,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface OverrideAnalysisResult200ResponseData
 */
export interface OverrideAnalysisResult200ResponseData {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    organization_id?: string;
    /**
     * 
     */
    screener_analysis_result_id: string;
    /**
     * 
     */
    created_by_user_id: string;
    /**
     * 
     */
    override_criteria_result: OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum;
    /**
     * 
     */
    override_reason: OverrideAnalysisResult200ResponseDataOverrideReasonEnum;
    /**
     * 
     */
    override_comment: string;
    /**
     * 
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     */
    is_medication_rule: boolean;
    /**
     * 
     */
    is_revert: boolean;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    updatedAt?: string;
    /**
     * 
     */
    created_by_user?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser;
}


/**
 * @export
 */
export const OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A',
} as const;
export type OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum = typeof OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum[keyof typeof OverrideAnalysisResult200ResponseDataOverrideCriteriaResultEnum];

/**
 * @export
 */
export const OverrideAnalysisResult200ResponseDataOverrideReasonEnum = {
    IncompleteOrMissingPatientData: 'Incomplete or missing patient data',
    NewInformationReceived: 'New information received',
    AiReasoningIssues: 'AI reasoning issues',
    AiExtractionOrReadingError: 'AI extraction or reading error',
    ClinicalJudgmentDiffers: 'Clinical judgment differs',
} as const;
export type OverrideAnalysisResult200ResponseDataOverrideReasonEnum = typeof OverrideAnalysisResult200ResponseDataOverrideReasonEnum[keyof typeof OverrideAnalysisResult200ResponseDataOverrideReasonEnum];


/**
 * Check if a given object implements the OverrideAnalysisResult200ResponseData interface.
 */
export function instanceOfOverrideAnalysisResult200ResponseData(value: object): value is OverrideAnalysisResult200ResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('screener_analysis_result_id' in value) || value['screener_analysis_result_id'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('override_criteria_result' in value) || value['override_criteria_result'] === undefined) return false;
    if (!('override_reason' in value) || value['override_reason'] === undefined) return false;
    if (!('override_comment' in value) || value['override_comment'] === undefined) return false;
    if (!('qualifier' in value) || value['qualifier'] === undefined) return false;
    if (!('is_medication_rule' in value) || value['is_medication_rule'] === undefined) return false;
    if (!('is_revert' in value) || value['is_revert'] === undefined) return false;
    return true;
}

export function OverrideAnalysisResult200ResponseDataFromJSON(json: any): OverrideAnalysisResult200ResponseData {
    return OverrideAnalysisResult200ResponseDataFromJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResult200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'screener_analysis_result_id': json['screener_analysis_result_id'],
        'created_by_user_id': json['created_by_user_id'],
        'override_criteria_result': json['override_criteria_result'],
        'override_reason': json['override_reason'],
        'override_comment': json['override_comment'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'is_medication_rule': json['is_medication_rule'],
        'is_revert': json['is_revert'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'created_by_user': json['created_by_user'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json['created_by_user']),
    };
}

export function OverrideAnalysisResult200ResponseDataToJSON(json: any): OverrideAnalysisResult200ResponseData {
    return OverrideAnalysisResult200ResponseDataToJSONTyped(json, false);
}

export function OverrideAnalysisResult200ResponseDataToJSONTyped(value?: OverrideAnalysisResult200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'screener_analysis_result_id': value['screener_analysis_result_id'],
        'created_by_user_id': value['created_by_user_id'],
        'override_criteria_result': value['override_criteria_result'],
        'override_reason': value['override_reason'],
        'override_comment': value['override_comment'],
        'qualifier': CriteriaQualifierToJSON(value['qualifier']),
        'is_medication_rule': value['is_medication_rule'],
        'is_revert': value['is_revert'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'created_by_user': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(value['created_by_user']),
    };
}

